import React from 'react';
import { PaymentMethods } from 'Components/widgets/payment-info/payment-form/PaymentMethods';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
type Props = {
  paymentProvider: PaymentProvider;
  shouldAutoSubmitForm?: boolean;
};
export const PaymentMethodsWrapper = ({ paymentProvider, shouldAutoSubmitForm }: Props) => {
  const appContext = useAppContext();
  const isCloselyIntegratedPaymentsProvider = paymentProvider.paymentMethods.length > 0;

  if (isCloselyIntegratedPaymentsProvider) {
    return (
      <PaymentMethods
        paymentProvider={paymentProvider}
        isPaymentProvider
        shouldSubmitFormOnPaymentChosen={!!shouldAutoSubmitForm}
      />
    );
  }

  if (appContext.isCmta && !appContext.cmta.isDelCredere) {
    // Card payment for seller wich are not del credere
    return null;
  }

  return (
    <div className="mb-10 flex justify-end text-12">
      <span className="mr-10 mt-2">{t('booking.banking.paymentProvider.Safedebit')}</span>
      <img alt={paymentProvider.label} className="h-20" src={paymentProvider.logo} />
    </div>
  );
};
